import { lazy } from 'react';
import AppRouterTemplate from './app-router-template';
import { getAppRoutesFromConfigs } from './get-app-routes-from-configs';
import { avonPatientRouteConfig } from './routes/avon-patient.routes';
import { callsPageRouteConfig } from './routes/calls-page.routes';
import { docketRouteConfig } from './routes/docket.routes';
import { guideListPageRouteConfig } from './routes/guide-list.routes';
import { loginPageRouteConfig } from './routes/login.routes';
import { memberDetailsRouteConfig } from './routes/member-details.routes';
import { memberListRouteConfig } from './routes/member-list.routes';
import { memberPageRouteConfig } from './routes/member-page.routes';
import { trainingAdminPageRouteConfig } from './routes/training-admin.routes';
import { adminDashboardRouteConfig } from './routes/admin-dashboard-routes';
import { hospitalizationRouteConfig } from './routes/hospitalization.routes';
import { noAccessPageRouteConfig } from './routes/no-access.routes';
import CareApp from '../care-app';
const ErrorPage = lazy(() =>
  import('./routes/StatusPages/ErrorPage').then(module => ({
    default: module.default,
  }))
);

export { getMemberPageUrl } from './navigation-hooks';
export { useAppNavigation } from './useAppNavigation';

const childRoutes = getAppRoutesFromConfigs([
  docketRouteConfig,
  memberListRouteConfig,
  memberPageRouteConfig,
  memberDetailsRouteConfig,
  callsPageRouteConfig,
  guideListPageRouteConfig,
  trainingAdminPageRouteConfig,
  loginPageRouteConfig,
  avonPatientRouteConfig,
  adminDashboardRouteConfig,
  hospitalizationRouteConfig,
  noAccessPageRouteConfig,
]);

export const routes = [
  {
    path: '/',
    element: <CareApp />,
    errorElement: <ErrorPage />,
    children: [
      {
        element: <AppRouterTemplate />,
        children: childRoutes,
        errorElement: <ErrorPage />,
      },
      {
        path: '*',
        element: <ErrorPage />,
      },
    ],
  },
];
